module.exports = __webpack_public_path__ + "static/media/excel_import_instructions.a7866bf4.png";